import React, { memo } from "react";
import { Button } from "react-bootstrap";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import LazyLoad from "react-lazyload";
import "./PaymentForm.scss";

function PaymentSuccessful() {
  const { id: classroomId } = useParams();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  // Extract responseMessage from URL query parameters
  const responseMessage = searchParams.get("responseMessage");

  // Decode the URL-encoded message
  const decodedMessage = responseMessage
    ? decodeURIComponent(responseMessage)
    : null;

  const handleDashboardNavigation = () => {
    navigate(`/student/myClassrooms/${classroomId}/dashboard`);
  };

  return (
    <div className="payment-success-page">
      <div className="success-icon-container">
        <div className="success-icon">
          <svg
            width="80"
            height="80"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <circle cx="12" cy="12" r="10" stroke="#28a745" strokeWidth="2" />
            <path
              d="M9 12L11 14L15 10"
              stroke="#28a745"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </div>
      </div>

      <h1 className="success-title mb-4">Payment Successful!</h1>

      <div className="success-message">
        {decodedMessage && (
          <p className="response-message mb-3">{decodedMessage}</p>
        )}
        <p className="default-message">
          You can now access your course content.
        </p>
      </div>
{/* 
      <div className="success-illustration">
        <LazyLoad height={300} offset={100}>
          <img
            width={500}
            height={500}
            src="/Saly-10.png"
            alt="Payment Success"
            className="success-image"
          />
        </LazyLoad>
      </div> */}

      <div className="success-actions">
        <Button
          className="dashboard-button"
          onClick={handleDashboardNavigation}
        >
          <svg
            width="16"
            height="16"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            style={{ marginRight: "8px" }}
          >
            <path
              d="M3 9L12 2L21 9V20C21 20.5304 20.7893 21.0391 20.4142 21.4142C20.0391 21.7893 19.5304 22 19 22H5C4.46957 22 3.96086 21.7893 3.58579 21.4142C3.21071 21.0391 3 20.5304 3 20V9Z"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M9 22V12H15V22"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
          Take Me To My Dashboard
        </Button>
      </div>

      <div className="success-help">
        <p className="help-text">Welcome to your learning journey! 🎉</p>
      </div>
    </div>
  );
}

export default memo(PaymentSuccessful);
